import type { IconDef } from '../types';

/** Line-drawn video camera: a rounded body with a lens wedge. */
export const videoOutlined: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M5.5 6h7a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-7a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3z',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: '1.9',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      d: 'M15.5 11l6-3.2v8.4l-6-3.2z',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: '1.9',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
  ],
};
